import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded'

export type BottomBarProps = {
  disabled?: boolean
  isFirst?: boolean
  isLast?: boolean
  onComplete?: () => void
  onNext?: () => void
  onPrevious?: () => void
}

const bottomBarMessages = {
  previous: msg`Previous`,
  next: msg`Next`,
  complete: msg`Complete`,
}

export function BottomBar(props: BottomBarProps) {
  const { disabled = false, isFirst = false, isLast = false, onComplete, onNext, onPrevious } = props
  const { i18n } = useLingui()
  return (
    <AppBar position="fixed" color="transparent" sx={{ top: 'auto', bottom: 0 }}>
      <ButtonGroup disableElevation variant="contained" sx={{ flex: 1 }}>
        {!isFirst && (
          <Button
            color="secondary"
            onClick={onPrevious}
            startIcon={<ArrowRightAltRoundedIcon sx={{ transform: 'rotate(180deg)' }} />}
            sx={{ borderRadius: 0, flex: 1, height: '50px' }}
          >
            {i18n._(bottomBarMessages.previous)}
          </Button>
        )}
        {!isLast ? (
          <Button disabled={disabled} onClick={onNext} endIcon={<ArrowRightAltRoundedIcon />} sx={{ borderRadius: 0, flex: 1, height: '50px' }}>
            {i18n._(bottomBarMessages.next)}
          </Button>
        ) : (
          <Button disabled={disabled} onClick={onComplete} sx={{ borderRadius: 0, flex: 1, height: '50px' }}>
            {i18n._(bottomBarMessages.complete)}
          </Button>
        )}
      </ButtonGroup>
    </AppBar>
  )
}

export default BottomBar
